// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { SendAllResponseFragment } from '../../fragments/generated/send-all-response.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SendElectronicInvoicesMutationVariables = Types.Exact<{
  invoiceIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type SendElectronicInvoicesMutationResult = { __typename?: 'Mutation', sendElectronicInvoices: { __typename?: 'SendAllResponseDTO', results: Array<{ __typename?: 'SendResultDTO', error: string | null, invoiceId: number }> } };

export const SendElectronicInvoicesGql = gql`
    mutation SendElectronicInvoices($invoiceIds: [Int!]!) {
  sendElectronicInvoices(invoiceIds: $invoiceIds) {
    ...SendAllResponse
  }
}
    ${SendAllResponseFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SendElectronicInvoicesInjectable extends Apollo.Mutation<SendElectronicInvoicesMutationResult, SendElectronicInvoicesMutationVariables> {
    override document = SendElectronicInvoicesGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */